<template>
    <el-dialog custom-class="dialog-case-detail" :visible.sync="visible"
               append-to-body
               @open="open">
        <div class="left">
            <GeminiScrollbar>
                <img v-lazy="detail.detailImgUrl +'?x-oss-process=image/resize,w_1000,limit_0'" class="top-img"  :key="detail.detailImgUrl+'?x-oss-process=image/resize,w_1000,limit_0'">
                <div class="desc main-desc" v-html="detail.desc"></div>
                <div class="room-group-list">
                    <div v-for="(item,index) in detail.roomGroupList" :key="index" class="item-group">
                        <div class="item-name">
                            <div class="oval"></div>
                            <span class="item--group-title">{{item.name}}</span>
                        </div>
                        <div class="desc" v-html="item.desc"></div>
                        <div class="img-group-list">
                            <img :src="imgUrl+'?x-oss-process=image/resize,w_1000,limit_0'"  v-for="(imgUrl,index) in item.imgList" :key="index">
                        </div>
                    </div>
                </div>
            </GeminiScrollbar>
        </div>
        <div class="right">
            <div class="case-info">
                <div class="title ellipsis">{{detail.title}}</div>
                <div class="subtitle ellipsis">{{detail.subTitle}}</div>
                <div class="tag-list">
                    <span class="tag-item" v-for="(tag,index) in detail.tagList" :key="index">{{tag}}</span>
                </div>
                <div class="view-list">
                    <span class="view-item">
                        <font-awesome-icon icon="eye" style="color: #000000;"></font-awesome-icon>
                        <span class="value">{{detail.hits}}</span>
                    </span>
                    <span class="view-item">
                        <font-awesome-icon icon="heart"></font-awesome-icon>
                         <span class="value">{{detail.love}}</span>
                    </span>
                </div>
            </div>
            <div class="date">发布时间：{{detail.releaseTime}}</div>
            <div style="padding: 20px">
                <app-button class="like-btn" @click.native="praise()">
                    <font-awesome-icon icon="heart"></font-awesome-icon>
                    <span>{{detail.isLove =='1' ? '已点赞':'赞'}}</span>
                </app-button>
            </div>
        </div>

    </el-dialog>
</template>

<script>
    export default {
        metaInfo(){
            return {
                meta:[{
                    name: 'description',
                    content: `${this.detail.desc}`,
                },{
                    name: 'keywords',
                    content: `${this.detail.title}`
                }]
            }
        },
        data() {
            return {
                detail: {},
                visible:false,
                swiperOpts: {
                    autoHeight: true
                }
            }
        },
        props: {
            id: '',
        },
        components: {

        },
        methods: {
            open() {
                this.$api.getCaseDetail({
                    id: this.id
                }).then(res => {
                    this.detail = res
                });
                this.$api.readAdd({
                    id: this.id,
                    readType:1
                }).then(res => {
                    this.detail.hit = res.count;
                });
            },
            praise(){
                this.$api.praise({
                    itemId: this.id,
                    itemType:1,
                    op:this.detail.isLove == '1'?'remove':'add'
                }).then(res=>{
                    this.detail.love = res.count;
                    this.detail.isLove = this.detail.isLove == '1'?0:1;
                    this.$parent.changeCase = {
                        id:this.id,
                        love:res.count
                    };
                });
            }
        },
        created() {

        }

    }
</script>
<style lang="scss" type="text/scss">
    .v-modal {
        opacity: .85;
        background: #000;
    }

    .dialog-case-detail {
        width: 1174px;
        margin-top: 3vh !important;
        height: 97vh !important;
        margin-bottom: 0;
        .el-dialog__header {
            padding:0;
        }
        .el-dialog__body {
            height: 100%;
            padding: 0;
        }
    }
</style>

<style lang="scss" type="text/scss" scoped>
    .el-dialog__wrapper {
        overflow: hidden;
    }

    .dialog-case-detail {
        border-radius:3px;
        .left {
            height: 100%;
            width: 863px;
            display: inline-block;
            .top-img {
                width: 100%;
            }
            .desc {
                max-width: 630px;
                margin: auto;
                color: #1F1F1F;
                font-size: 16px;
                /*font-weight:300;*/
                line-height: 32px;
                font-family: PingFangSC-Light;
            }
            .main-desc {
                margin: 50px auto;
            }
            .item-group {
                margin-bottom: 50px;
                &:last-child {
                    margin-bottom: 0;
                    .img-group-list {
                        img {
                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }
                .item-name {
                    max-width: 630px;
                    margin: 0 auto 10px;
                }
                .item--group-title {
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 32px;
                    color: $title-color;
                    vertical-align: middle;
                }
                .oval {
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 8px;
                }
                /*.swiper-container{*/
                /*margin-top: 20px;*/
                /*}*/
                .img-group-list {
                    margin-top: 50px;
                    img {
                        width: 100%;
                        margin-bottom: 20px;
                    }
                }
            }
        }
        .right {
            width: 311px;
            height: 100%;
            display: inline-block;
            vertical-align: top;
            .case-info{
                padding: 20px;
                .title{
                    font-size:13px;
                    font-weight:600;
                    line-height:18px;
                    margin-bottom: 2px;
                    color: $title-color;
                }
                .subtitle{
                    font-size:11px;
                    font-weight:300;
                    line-height:16px;
                    color: #B8B8B8;
                    margin-bottom: 10px;
                }
                .tag-item{
                    padding: 4px 8px;
                    font-size: 11px;
                    color: #757575;
                    line-height: 18px;
                    letter-spacing: 1px;
                    background-color: #F5F5F5;
                    margin-right: 5px;
                }
                .view-list{
                    margin-top: 24px;
                }
                .view-item{
                    margin-right: 10px;
                   svg{
                       color: #000;
                       margin-right: 5px;
                       font-size: 10px;
                   }
                    .value{
                        color: #B8B8B8;
                        font-size:10px;
                        line-height:14px;
                        font-weight:300;
                    }
                }
            }
            .date{
                padding: 20px;
                border-top: 1px solid rgba(0,0,0,0.12);
                border-bottom: 1px solid rgba(0,0,0,0.12);
                line-height:14px;
                font-size: 10px;
            }
            .like-btn{
                width: 100%;
                height: 40px;
                background-color: #E59D9D;
                border-radius:3px;
                color: #fff;
                font-size:13px;
                span{
                    margin-left: 5px;
                }
            }
        }
    }

</style>
